export default __webpack_public_path__ + "static/media/whyPage-howTab.be45cd6a.svg";